<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">

            <!-- 保单号 -->
            <el-table-column align="left" label="保单号" >
            <template slot-scope="scope">
                <!-- <span v-if="$perm(['company.view_insurance_company'])" class="text-link"
                    @click="handleUpdate(scope.row.id)">{{scope.row.policy_number}}</span> -->
                <span>{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <!-- 险种 -->
            <el-table-column align="left" label="险种" >
            <template slot-scope="scope">
                <span>{{ scope.row.insruance_type }}</span>
            </template>
            </el-table-column>

            <!-- 投保人 -->
            <el-table-column align="left" label="投保人" >
            <template slot-scope="scope">
                <span>{{ scope.row.policy_holder }}</span>
            </template>
            </el-table-column>

            <!-- 被保险人 -->
            <el-table-column align="left" label="被保险人" >
            <template slot-scope="scope">
                <span>{{ scope.row.insured}}</span>
            </template>
            </el-table-column>

            <!-- 车牌号-->
            <el-table-column align="left" label="车牌号" >
            <template slot-scope="scope">
                <span>{{ scope.row.number_plate}}</span>
            </template>
            </el-table-column>

            <!-- 手机号-->
            <el-table-column align="left" label="手机号" >
            <template slot-scope="scope">
                <span>{{ scope.row.mobile}}</span>
            </template>
            </el-table-column>

            <!-- 保单币种-->
            <el-table-column align="left" label="保单币种" >
            <template slot-scope="scope">
                <span>{{ scope.row.policy_currency}}</span>
            </template>
            </el-table-column>

            <!-- 实收保费 -->
            <el-table-column align="left" label="实收保费" >
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 不含税保费 -->
            <el-table-column align="left" label="不含税保费" >
            <template slot-scope="scope">
                <span>{{ scope.row.tax_free_premium | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 实收日期 -->
            <el-table-column align="left" label="实收日期" >
            <template slot-scope="scope">
                <span>{{ scope.row.paid_time | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <!-- 手续费比率 -->
            <el-table-column align="left" label="手续费率" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission_rate}}</span>
            </template>
            </el-table-column>

            <!-- 手续费-->
            <el-table-column align="left" label="手续费" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 手续费2-->
            <el-table-column align="left" label="手续费2" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission2 | parsecurrency }}</span>
            </template>
            </el-table-column>

            <!-- 尾差-->
            <el-table-column align="left" label="尾差" >
            <template slot-scope="scope">
                <span>{{ scope.row.tail_difference}}</span>
            </template>
            </el-table-column>

            <!-- 业务部门-->
            <el-table-column align="left" label="业务部门" >
            <template slot-scope="scope">
                <span>{{ scope.row.business_unit}}</span>
            </template>
            </el-table-column>

            <!-- 业务员-->
            <el-table-column align="left" label="业务员" >
            <template slot-scope="scope">
                <span>{{ scope.row.salesman}}</span>
            </template>
            </el-table-column>

            <!-- 出单员-->
            <el-table-column align="left" label="出单员" >
            <template slot-scope="scope">
                <span>{{ scope.row.orderer}}</span>
            </template>
            </el-table-column>

            <!-- 代理点-->
            <el-table-column align="left" label="代理点" >
            <template slot-scope="scope">
                <span>{{ scope.row.agent_point}}</span>
            </template>
            </el-table-column>

        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
export default {
    name: 'billing-record-list-zi-jin',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        let v = parseFloat(value).toFixed(4)
        return formatCurrency(v, 2)
      },
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>
